import { getAllWorkstations, getDataByWorkstationId, getActiveProductionOrders, getActiveProductionOrdersByProduct, getEventHistory, getPrintHistory, getLatestNotifications } from './workstation';
import { getProductDataByEAN, getProductionOrdersByEAN } from './product';
import { getPalletDataBySSCC, getPrintPreviewBySSCC, printLabel, getNewPalletNumber } from './pallet';
import { validateCredentials, authenticate, getAllMetisUsers, getAllBagweigherUsers, getAllMetisUserRoles, getAllMetisUserFeatures, createMetisUser, createBagweigherUser, updateMetisUser, updateBagweigherUser, getAllEditableMetisUserFeatures, CheckIfBadgeNumberIsFree, DeleteMetisUser } from './user';
import { getSystemParametersByIdList} from './general';

export const dataService = {
    getAllWorkstations,
    getPalletDataBySSCC,
    getProductDataByEAN,
    getProductionOrdersByEAN,
    getDataByWorkstationId,
    validateCredentials,
    getActiveProductionOrders,
    getActiveProductionOrdersByProduct,
    getPrintPreviewBySSCC,
    getNewPalletNumber,
    printLabel,
    getEventHistory,
    getPrintHistory,
    getAllMetisUsers,
    getAllBagweigherUsers,
    getAllMetisUserRoles,
    getAllMetisUserFeatures,
    getAllEditableMetisUserFeatures,
    createMetisUser,
    createBagweigherUser,
    updateMetisUser,
    updateBagweigherUser,
    authenticate,
    getLatestNotifications,
    getSystemParametersByIdList,
    CheckIfBadgeNumberIsFree,
    DeleteMetisUser
};
